class BackgroundVideo {
    static attach() {
        const backgroundVideoElement = document.querySelector(".js-bg-video");

        if (backgroundVideoElement) {
            /* eslint-disable-next-line no-unused-vars */
            const backgroundVideo = new BackgroundVideo(backgroundVideoElement);
        }
    }

    constructor(element) {
        this.element = element;

        this.headerElement = document.querySelector(".js-header");
        this.footerElement = document.querySelector(".js-footer");

        this.watchScroll();
        this.watchResize();
        this.reposition();
    }

    watchScroll() {
        let inProcess = false;

        window.addEventListener(
            "scroll",
            () => {
                if (!inProcess) {
                    inProcess = true;
                    window.requestAnimationFrame(() => {
                        this.reposition();
                        inProcess = false;
                    });
                }
            },
            { passive: true }
        );
    }

    watchResize() {
        let inProcess = false;

        window.addEventListener(
            "resize",
            () => {
                if (!inProcess) {
                    inProcess = true;
                    window.requestAnimationFrame(() => {
                        this.reposition();
                        inProcess = false;
                    });
                }
            },
            { passive: true }
        );
    }

    repositionAvoidHeader() {
        const { scrollY } = window;
        const headerHeight = this.headerElement.clientHeight;

        if (scrollY < headerHeight) {
            this.element.style.top = `${headerHeight - scrollY}px`;
        } else {
            this.element.style.top = 0;
        }
    }

    repositionAvoidFooter() {
        const { scrollY } = window;
        const bgVideoHeight = this.element.clientHeight;
        const footerHeight = this.footerElement.clientHeight;
        const bodyHeight = document.body.clientHeight;

        if (scrollY > bodyHeight - (bgVideoHeight + footerHeight)) {
            this.element.style.top = "auto";
            this.element.style.bottom = `${
                bgVideoHeight - (bodyHeight - (scrollY + footerHeight))
            }px`;
        } else {
            this.element.style.top = 0;
            this.element.style.bottom = "auto";
        }
    }

    reposition() {
        this.repositionAvoidHeader();
    }
}

export { BackgroundVideo };
